import { Table } from "react-bootstrap";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext.js";

function PartnerApiDocsRequestParams(props) {
    const {className, params = []} = props;
    const {getLangPath} = useLangContext();

    return <div className={className}>
        <h4>{getLangPath('partner.api_docs.request_parameters')}</h4>
        <Table striped bordered hover variant="dark">
            <thead>
            <tr>
                <th>{getLangPath('partner.api_docs.name')}</th>
                <th>{getLangPath('partner.api_docs.description')}</th>
                <th>{getLangPath('partner.api_docs.type')}</th>
                <th>{getLangPath('partner.api_docs.required')}</th>
            </tr>
            </thead>
            <tbody>
            {
                params.map(param => (
                        <tr key={param.name}>
                            <td>{param.name}</td>
                            <td dangerouslySetInnerHTML={{__html: getLangPath(param.description)}}/>
                            <td>{getLangPath(param.type)}</td>
                            <td>{getLangPath(`partner.api_docs.${param.required ? 'mandatory' : 'optional'}`)}</td>
                        </tr>
                ))
            }
            </tbody>
        </Table>
    </div>
}

export default PartnerApiDocsRequestParams;
